import { render, staticRenderFns } from "./SharedCollection.vue?vue&type=template&id=ad6d34ea"
import script from "./SharedCollection.vue?vue&type=script&lang=js"
export * from "./SharedCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports